module.exports = __webpack_public_path__ + "img/willyou.9cbf9320.svg";